import {
  Button,
  Div,
  H3,
  Icon,
  Img,
  P,
  PlusIcon,
  noAvailability,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useState } from 'react';
import { ModifierGroupComponent } from './ModifierComponents';
import { AddEditAvailability } from './AddEditAvailability';
import { MenuV2Response } from 'components/src/types/menu.types';

export const Availability = ({
  menu,
  setMenu,
  setLoading,
  handleChangeShouldPublish,
  isPos,
}: {
  menu: MenuV2Response | null;
  setMenu: Dispatch<SetStateAction<MenuV2Response | null>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
  handleChangeShouldPublish: (shouldPublish: boolean) => void;
  isPos: boolean;
}) => {
  const [addModal, setAddModal] = useState(false);

  const AddAvailabilityButton = () => {
    return (
      <Button $selected onClick={() => setAddModal(true)}>
        Add Availability
      </Button>
    );
  };

  return (
    <>
      <Div $flex $between $alignCenter $mb="20">
        <H3 $mb="0">Availability ({menu?.availability?.length})</H3>
        {!isPos && menu?.availability && menu?.availability?.length > 0 && (
          <Icon $pointer onClick={() => setAddModal(true)}>
            <PlusIcon />
          </Icon>
        )}
      </Div>

      {menu?.availability?.map((item, i) => (
        <ModifierGroupComponent
          key={i}
          item={item}
          menu={menu}
          setMenu={setMenu}
          setLoading={setLoading}
          handleChangeShouldPublish={handleChangeShouldPublish}
          isPos={isPos}
        />
      ))}

      {menu?.availability && menu?.availability?.length < 1 && (
        <Div $flex $column $alignCenter>
          <Img alt="" $width="180px" src={noAvailability} $mb="24" />
          <H3 $mb="12" $center>
            No Availability
          </H3>
          <P $mb="24" $center>
            This provider currently don’t have <br /> menu availability.
          </P>
          {!isPos && <AddAvailabilityButton />}
        </Div>
      )}

      <AddEditAvailability
        modalIsOpen={addModal}
        closeModal={() => {
          setAddModal(false);
        }}
        setLoading={setLoading}
        setMenu={setMenu}
        handleChangeShouldPublish={handleChangeShouldPublish}
      />
    </>
  );
};
